import React, {FC} from 'react';

import {Box, DialogContent, Stack, Typography, useMediaQuery} from '@mui/material';
import {t} from 'i18next';

import Button from 'components/button/Button';
import theme from 'config/theme';
import ReactNative from 'services/react-native';

import {BasketDialogTitle} from './BasketDialogTitle';
import {StyledDialog, StyledBottomSheet} from './styles';

export interface IAddressChangedModal {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}

export const AddressChangedModal: FC<IAddressChangedModal> = ({open, onClose, onSave}) => {
  const isMobileView = useMediaQuery(theme.breakpoints.only('mobile'));
  const isMobileScreen = ReactNative.isReactNativeWebView() || isMobileView;
  const ModalContainer = isMobileScreen ? StyledBottomSheet : StyledDialog;
  return (
    <ModalContainer
      className="MakroFleetDeliveryModal"
      open={open}
      onClose={onClose}
      anchor="bottom"
      ModalProps={{style: {zIndex: 1300}}}
    >
      <BasketDialogTitle title={t('addressChanged.title')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Box display="flex" gap={1} p={1} width="fit-content">
            <Typography fontSize={14} fontWeight={400}>
              {t('addressChanged.description')}
            </Typography>
          </Box>
          <Stack gap={2}>
            <Button fullWidth shape="rounded" variant="contained" disabled={false} onClick={onSave}>
              {t('addressChanged.button.use')}
            </Button>

            <Button fullWidth shape="rounded" variant="outlined" disabled={false} onClick={onClose}>
              {t('addressChanged.button.back')}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

AddressChangedModal.displayName = 'AddressChangedModal';
